import {Text, Typography} from '@yandex-delivery/blocks'
import React from 'react'
import i18n from 'src/shared/i18n'

import {Button} from '../../button'
import {DOWNLOAD_YANDEX_APP} from '../../promo'

type Props = {
  onClick: JSX.IntrinsicElements['a']['onClick']
}

const YandexPromoButton: React.FC<Props> = ({onClick}) => {
  return (
    <Button fullWidth href={DOWNLOAD_YANDEX_APP} onClick={onClick} target="_blank" variant="action">
      <Text>
        <Typography thickness="medium" variant="body2">
          {i18n.print('route_postcard_download_app')}
        </Typography>
        <Typography variant="caption1">{i18n.print('route_postcard_download_text')}</Typography>
      </Text>
    </Button>
  )
}

export default YandexPromoButton
